// extracted by mini-css-extract-plugin
export default {"diagnosis-chip-container":"DiagnosisChip_diagnosis-chip-container__Ql0Qx","diagnosis-chip":"DiagnosisChip_diagnosis-chip__ubzG6"};